import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeSiteProvider } from './context/ThemeContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <ThemeSiteProvider>
      <App />
    </ThemeSiteProvider>


  </React.StrictMode>
);

